import CaptainFlowStepAPI from 'dashboard/api/captain/flowStep';

const state = {
  records: {}, // keyed by assistantId
  uiFlags: { fetching: false, saving: false, deleting: false },
};

const getters = {
  getStepsForAssistant: s => assistantId => s.records[assistantId] || [],
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET(s, { assistantId, steps }) {
    s.records = { ...s.records, [assistantId]: steps };
  },
  ADD(s, { assistantId, step }) {
    const list = s.records[assistantId] || [];
    s.records = { ...s.records, [assistantId]: [...list, step] };
  },
  UPDATE(s, { assistantId, step }) {
    const list = s.records[assistantId] || [];
    s.records = {
      ...s.records,
      [assistantId]: list.map(it => (it.id === step.id ? step : it)),
    };
  },
  REMOVE(s, { assistantId, stepId }) {
    const list = s.records[assistantId] || [];
    s.records = {
      ...s.records,
      [assistantId]: list.filter(it => it.id !== stepId),
    };
  },
  SET_FLAG(s, flag) {
    s.uiFlags = { ...s.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }, assistantId) {
    commit('SET_FLAG', { fetching: true });
    try {
      const { data } = await CaptainFlowStepAPI.list({ assistantId });
      commit('SET', { assistantId, steps: data });
      return data;
    } finally {
      commit('SET_FLAG', { fetching: false });
    }
  },

  async create({ commit }, { assistantId, payload }) {
    commit('SET_FLAG', { saving: true });
    try {
      const { data } = await CaptainFlowStepAPI.create({
        assistantId,
        payload,
      });
      commit('ADD', { assistantId, step: data });
      return data;
    } finally {
      commit('SET_FLAG', { saving: false });
    }
  },

  async update({ commit }, { assistantId, stepId, payload }) {
    commit('SET_FLAG', { saving: true });
    try {
      const { data } = await CaptainFlowStepAPI.update({
        assistantId,
        stepId,
        payload,
      });
      commit('UPDATE', { assistantId, step: data });
      return data;
    } finally {
      commit('SET_FLAG', { saving: false });
    }
  },

  async delete({ commit }, { assistantId, stepId }) {
    commit('SET_FLAG', { deleting: true });
    try {
      await CaptainFlowStepAPI.delete({ assistantId, stepId });
      commit('REMOVE', { assistantId, stepId });
    } finally {
      commit('SET_FLAG', { deleting: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
